import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const PropertyUWInvestmentManagementPricingNotes = ({ classes, notes }) => {
    return (
        <div className={classes.containerClass}>
            <Typography variant='subtitle2'>IM Pricing Notes</Typography>
            <Typography variant='body2'>
                {notes || ''}
            </Typography>
        </div>
    )
}
const styles = theme => ({
    containerClass: {
        flexGrow: 1,
        // height: '50%',
        overflowY: 'auto'
    }
});

const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
})
export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(PropertyUWInvestmentManagementPricingNotes);